"use client";

import { useEffect } from "react";
import { useLanguage } from "@/i18n/LanguageContext";
import { useHreflang } from "@/i18n/useHreflang";
import BlogHero from "./components/BlogHero";
import FeaturedArticle from "./components/FeaturedArticle";
import ArticlesGrid from "./components/ArticlesGrid";
import CategoriesStrip from "./components/CategoriesStrip";
import NewsletterStrip from "./components/NewsletterStrip";
import BlogCtaFooter from "./components/BlogCtaFooter";
import { injectMetaTags } from "@/lib/seoHelpers";

export default function BlogPage() {
  const { currentLang } = useLanguage();
  useHreflang();
  const isEs = currentLang === "es";

  useEffect(() => {
    const titleEn = "Window Repair Blog \u2014 Miami Salt Air Insights";
    const titleEs = "Blog de Reparaci\u00F3n de Ventanas \u2014 Informaci\u00F3n Aire Salino Miami";
    document.title = isEs
      ? `${titleEs} \u2014 Windows and Doors Repair LLC Miami`
      : `${titleEn} \u2014 Windows and Doors Repair LLC Miami`;

    const descEn = "Blog articles on window repair, maintenance, and hurricane preparedness for Miami-Dade homeowners.";
    const descEs = "Art\u00EDculos sobre reparaci\u00F3n de ventanas, mantenimiento y preparaci\u00F3n para huracanes para due\u00F1os de casa en Miami-Dade.";

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", isEs ? descEs : descEn);

    const cleanupSeo = injectMetaTags({
      title: isEs ? titleEs : titleEn,
      description: isEs ? descEs : descEn,
      url: isEs
        ? "https://impact-window-repair-miami.com/es/blog/"
        : "https://impact-window-repair-miami.com/blog/",
      image: "https://impact-window-repair-miami.com/og/og-blog.jpg",
      imageAlt: isEs ? "Blog de reparaci\u00F3n de ventanas Miami" : "Miami window repair blog",
      breadcrumbs: [
        {
          name: isEs ? "Inicio" : "Home",
          item: "https://impact-window-repair-miami.com/",
        },
        {
          name: "Blog",
          item: "https://impact-window-repair-miami.com/blog/",
        },
      ],
      type: "website",
    });

    const schema = {
      "@context": "https://schema.org",
      "@type": "Blog",
      name: isEs ? "Blog de Reparaci\u00F3n de Ventanas Miami" : "Miami Window Repair Insights",
      url: "https://impact-window-repair-miami.com/blog/",
      inLanguage: isEs ? "es-US" : "en-US",
      publisher: {
        "@type": "Organization",
        name: "Windows and Doors Repair LLC",
        telephone: "+17863774452",
        address: {
          "@type": "PostalAddress",
          streetAddress: "848 Brickell Ave, PH-5",
          addressLocality: "Miami",
          addressRegion: "FL",
          postalCode: "33131",
          addressCountry: "US",
        },
      },
    };

    const existing = document.getElementById("blog-schema");
    if (existing) document.head.removeChild(existing);
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.id = "blog-schema";
    s.text = JSON.stringify(schema);
    document.head.appendChild(s);

    return () => {
      cleanupSeo();
      const el = document.getElementById("blog-schema");
      if (el) document.head.removeChild(el);
    };
  }, [isEs]);

  return (
    <main>
      <BlogHero />
      <FeaturedArticle />
      <CategoriesStrip />
      <ArticlesGrid />
      <NewsletterStrip />
      <BlogCtaFooter />
    </main>
  );
}